import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { ReminderCreate } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class RemindersService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    create(reminderCreateData: ReminderCreate): Observable<ReminderCreate> {
        return this.http.post<ReminderCreate>(
            `${this.config.getConfiguration().API_BASE}/reminder`,
            reminderCreateData,
        );
    }

    delete(reminderId: string): Observable<any> {
        return this.http.delete<any>(
            `${this.config.getConfiguration().API_BASE}/reminder/${reminderId}`,
        );
    }
}
